/* eslint-disable no-nested-ternary */
import React from 'react';

import { useMediaQuery } from '@material-ui/core';
import { getMobileDetailInfo } from 'src/hooks/useMobileSystem';

import DesktopBanner from 'src/images/homepage-20250811/app-upsell-desktop.png';
import AppstoreBanner from 'src/images/homepage-20250811/appstore-mobile.png';
import PlaystoreBanner from 'src/images/homepage-20250811/playstore-mobile.png';

import styles from './AppUpSell.module.scss';

export default function AppUpSell() {
  const isMobile = useMediaQuery('(max-width:600px)');
  const { os } = getMobileDetailInfo();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {isMobile ? (
          os === 'iOS' ? (
            <a
              href="https://paidy.onelink.me/GTiS/toppage"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="App Store Banner"
                src={AppstoreBanner}
                width={343}
                height={81}
                className={styles.img}
              />
            </a>
          ) : os === 'Android' ? (
            <a
              href="https://paidy.onelink.me/KTFT/PC"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="Play Store Banner"
                src={PlaystoreBanner}
                width={343}
                height={81}
                className={styles.img}
              />
            </a>
          ) : null
        ) : (
          <div className={styles.desktopBanners}>
            <a
              href="https://paidy.onelink.me/eV85/PC"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                alt="App Up Sell Banner"
                src={DesktopBanner}
                width={529}
                height={128}
                className={styles.img}
              />
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
